const DATE_FMT = 'ddd, MMM DD, YYYY';
const TIME_FMT = 'h:mm a';

export {
  DATE_FMT,
  TIME_FMT
}
